import React from 'react';
import MainBanner from '../components/MainBanner/MainBanner';
import LeftRightTales from '../components/LeftRightTales/LeftRightTales';
import { FeatureItem } from '../components/LeftRightTales/FeatureItem';
import one from '../assets/everyone.webp'
import two from '../assets/choir.webp'
import { useTranslation } from 'react-i18next';

const Home: React.FC = () => {
  const { t } = useTranslation();
  const features: FeatureItem[] = [
    {
      image: one,
      title: t("underMainBanner.feature1.title"),
      description:
        t("underMainBanner.feature1.description"),
      imagePosition: "left",
    },
    {
      image: two,
      title: t("underMainBanner.feature2.title"),
      description:
        t("underMainBanner.feature2.description"),
      imagePosition: "right",
    },
  ];
  return (
  <>
    <MainBanner/>
    <LeftRightTales features={features}/>
  </>
  );
};

export default Home;